import {
  queryAddEditApiCallResponse,
  queryAddNewApiCallResponse,
  queryDeleteItem,
  queryEditItemApiCallResponse,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'apiCallResponse',
  state: {
    newApiCallResponse: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select:
      'id,responseHttpStatusCode,parameterCodification,tableParameterName,parameterName,valueDestination,parameterValueFilterComparisonOperator,parameterValueFilter,responseParameterPosition',
    notSelectSearch:
      'responseHttpStatusCode,parameterCodification,valueDestination,parameterValueFilterComparisonOperator,parameterValueFilter,responseParameterPosition',
    expand: {
      form: { select: 'name' },
      field: { select: 'displayText' },
      variable: { select: 'internalName' },
    },
    paramsView: {
      select:
        'id,responseHttpStatusCode,parameterCodification,tableParameterName,parameterName,valueDestination,parameterValueFilterComparisonOperator,parameterValueFilter,created,updated,responseParameterPosition,formFieldValueDestination',
      expand: {
        form: { select: 'name' },
        field: { select: 'displayText' },
        variable: { select: 'internalName' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryApiCallResponses',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewApiCallResponse({ payload }, { put }) {
      yield put({
        type: 'addApiCallResponse',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewApiCallResponse',
          payload,
        });
      }
    },

    *editItemApiCallResponse({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemApiCallResponse, payload);
        yield put({
          type: 'editApiCallResponse',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewApiCallResponse({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewApiCallResponse, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallResponse',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditApiCallResponse({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditApiCallResponse, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallResponse',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallResponse',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemApiCallResponse({ view }, { put }) {
      yield put({
        type: 'showEditItemApiCallResponse',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryApiCallResponses(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addApiCallResponse(state, { payload }) {
      return {
        ...state,
        newApiCallResponse: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewApiCallResponse(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editApiCallResponse(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveApiCallResponse(state, { payload }) {
      return {
        ...state,
        saveApiCallResponse: payload,
        newApiCallResponse: false,
        selectedItem: false,
      };
    },

    showEditItemApiCallResponse(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newApiCallResponse: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
